import { VehicleStatus } from '@/@types/generated'
import { register } from './enum'

const VehicleStatusLabels: Record<VehicleStatus, string> = {
  [VehicleStatus.ACTIVE]: 'Active',
  [VehicleStatus.INACTIVE]: 'Inactive',
  [VehicleStatus.EXPIRED]: 'Expired',
  [VehicleStatus.ARCHIVED]: 'Deleted',
}

export const VehicleStatusTextColor: Record<VehicleStatus, string> = {
  [VehicleStatus.ACTIVE]: 'text-success',
  [VehicleStatus.EXPIRED]: 'text-warning',
  [VehicleStatus.INACTIVE]: 'text-gray-500',
  [VehicleStatus.ARCHIVED]: 'text-destructive',
}

register<VehicleStatus>(VehicleStatus, (v) => {
  if (!v) return '\u2014'
  return VehicleStatusLabels[v]
})
